import React from 'react';
import { Button } from '@osui/ui';
import { useSubmitState } from './hooks';
import { jsx as _jsx } from "react/jsx-runtime";
export function Submit({
  onSubmit,
  ...props
}) {
  const {
    form,
    state
  } = useSubmitState();
  const onClick = React.useCallback(() => {
    form.submit(onSubmit);
  }, [form, onSubmit]);
  return /*#__PURE__*/_jsx(Button, {
    onClick: onClick,
    size: "large",
    ...props,
    htmlType: 'submit',
    loading: state.submitting,
    children: props.children || '提交'
  });
}
Submit.displayName = "Submit";
Submit.defaultProps = {
  type: 'primary',
  htmlType: 'submit'
};
//# sourceMappingURL=es/Other/Submit/Submit.js.map